/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// Custom JS for Box Calculation 

function domReady(fn) {
    document.addEventListener("DOMContentLoaded", fn);
    if (document.readyState === "interactive" || document.readyState === "complete" ) {
        fn();
    }
}

function attachLightboxListeners() {
    const lightbox = document.querySelector('.carillo-lightbox');
    if (!lightbox) {
        return;
    }

    const closeButton = lightbox.querySelector('button.close');
    const prevButton = lightbox.querySelector('button.prev');
    const nextButton = lightbox.querySelector('button.next');
    if (closeButton) {
        closeButton.addEventListener('click', closeLightbox);
    }
    if (prevButton) {
        prevButton.addEventListener('click', changeLightbox);
    }
    if (nextButton) {
        nextButton.addEventListener('click', changeLightbox);
    }
}

function setLightboxImageProps(src, aspectRatio) {
    const lightboxImageContainer = document.querySelector('.carillo-lightbox .aspect-ratio');
    const lightboxImage = lightboxImageContainer.querySelector('img');

    lightboxImageContainer.style.paddingBottom = 100 / aspectRatio + '%';
    lightboxImage.src = src;
    lightboxImage.dataset.src = src;
}

function showHidePrevNextButtons(currentImage) {
    const prevButton = document.querySelector('.carillo-lightbox .prev');
    const nextButton = document.querySelector('.carillo-lightbox .next');
    prevButton.classList.remove('hide');
    nextButton.classList.remove('hide');

    const productGalleryImages = [...document.querySelectorAll('.product-gallery__carousel-item .product-gallery__image')];
    const currentIndex = productGalleryImages.findIndex(img => img.dataset.zoom === currentImage.dataset.zoom);
    
    if (currentIndex === 0) {
        prevButton.classList.add('hide');
    }

    if (currentIndex === productGalleryImages.length - 1) {
        nextButton.classList.add('hide')
    }
}

function changeLightbox(e) {
    const productGalleryImages = [...document.querySelectorAll('.product-gallery__carousel-item .product-gallery__image')];
    const lightboxImage = document.querySelector('.carillo-lightbox img');
    const currentIndex = productGalleryImages.findIndex(galleryImage => galleryImage.dataset.zoom === lightboxImage.dataset.src);

    let newImg;
    if (e.target.classList.contains('prev')) {
        newImg = productGalleryImages[currentIndex - 1];
    } else if (e.target.classList.contains('next')) {
        newImg = productGalleryImages[currentIndex + 1];
    }

    setLightboxImageProps(newImg.dataset.zoom, newImg.dataset.aspectRatio);
    showHidePrevNextButtons(newImg);
}

function closeLightbox() {
    const lightbox = document.querySelector('.carillo-lightbox');
    lightbox.classList.remove('open');
}

function openLightbox(e) {
    const isDesktop = window.matchMedia('screen and (min-width: 1024px)').matches;
    if (!isDesktop) {
        return;
    }
    showHidePrevNextButtons(e.target);

    const lightbox = document.querySelector('.carillo-lightbox');

    setLightboxImageProps(e.target.dataset.zoom, e.target.dataset.aspectRatio);
    lightbox.classList.add('open');
}

function displaySubtotal(subtotal) {
    const displaySubtitleEl = document.querySelector('#subtotal');
    displaySubtitleEl.textContent = `$${subtotal.toFixed(2)}`;
}

function getSubtotal(numBoxes) {
    const pricePerBoxEl = document.querySelector('#pricePerBox');
    let pricePerBoxString = pricePerBoxEl ? pricePerBoxEl.textContent : '';
    if (pricePerBoxString.startsWith('$')) {
        pricePerBoxString = pricePerBoxString.substring(1);
    }

    const subtotal = numBoxes * parseFloat(pricePerBoxString);
    displaySubtotal(subtotal);
}

function hideElements(elements = []) {
    elements.forEach(element => {
        element.classList.add('hidden');
    });
}

function unhideElements(elements = []) {
    elements.forEach(element => {
        element.classList.remove('hidden');
    });
}

function getStockAtLocation(location) {
    const stockEl = document.querySelector(`#in_stock_boxes_${location}`);
    if (!stockEl) {
        return 0;
    }

    return parseInt(stockEl.textContent);
}

function updateInStockInfo(parentEl, isInStock) {
    if (!parentEl) {
        return;
    }

    if (isInStock) {
        parentEl.classList.add('in-stock');
    } else {
        parentEl.classList.remove('in-stock');
    }
}

function updateAddToCartButtonEnabled(isEnabled) {
    const button = document.querySelector('.product-form__add-button');
    if (!button) {
        return;
    }
    if (isEnabled) {
        button.removeAttribute('disabled');
        button.classList.remove('button--disabled');
    } else {
        button.setAttribute('disabled', true);
        button.classList.add('button--disabled');
    }
}

function setPickupStore(numBoxes) {
    const locationBlocks = [...document.querySelectorAll('.store-availability-information')];
    const stockTransferInfoEl = document.querySelector('#call-to-transfer');
    if (!locationBlocks.length || !stockTransferInfoEl) {
        return;
    }
    hideElements([...locationBlocks, stockTransferInfoEl]);

    const availableStockByLocation = {
        'Brantford Location': () => getStockAtLocation('brantford'),
        'Simcoe Location': () => getStockAtLocation('simcoe'),
    };

    const stockLocationInfo = locationBlocks.map(element => {
        const locationName = element.getAttribute('data-location');
        const availableStock = availableStockByLocation[locationName]();
        return {
            locationName,
            availableStock,
            element,
        };
    });

    const totalStock = stockLocationInfo.reduce((accumulatedValue, location) => location.availableStock + accumulatedValue, 0);
    if (totalStock < numBoxes) {
        unhideElements([stockLocationInfo[0].element]);
        updateInStockInfo(stockLocationInfo[0].element, false);
        updateAddToCartButtonEnabled(false);
        return;
    }

    updateAddToCartButtonEnabled(true);
    const locationWithEnoughStock = stockLocationInfo.find(location => location.availableStock >= numBoxes);
    if (locationWithEnoughStock) {
        unhideElements([locationWithEnoughStock.element]);
        updateInStockInfo(locationWithEnoughStock.element, true);
    } else {
        unhideElements([stockLocationInfo[0].element, stockTransferInfoEl]);
        updateInStockInfo(stockLocationInfo[0].element, true);
    }
}

function handleQuantityInputChange(e) {
    const numBoxes = parseInt(e.target.value) || 1;
    getSubtotal(numBoxes);
    setPickupStore(numBoxes);
}

function displayResults(numBoxes, size) {
    const numBoxesInput = document.querySelector('#num-boxes');
    const roomSizeInput = document.querySelector('#room-size');
    const totalSfInPurchaseSpan = document.querySelector('#purchase-sf');
    const quantityInputEl = document.querySelector('input[id=quantityUpdate]');

    quantityInputEl.value = numBoxes;
    quantityInputEl.dispatchEvent(new Event('input', { bubbles: true}));
    numBoxesInput.value = numBoxes || 1;
    roomSizeInput.value = size || 0;
    totalSfInPurchaseSpan.textContent = (numBoxes * totalSfInPurchaseSpan.dataset.sfPerBox).toFixed(2);
}

function calculateNumBoxes(e) {
    const sqftPerBoxEl = document.querySelector('#sqftBx');
    const sqftPerBox = parseFloat(sqftPerBoxEl.textContent);
    const size = parseFloat(e.target.value);
    if (!size) {
        return;
    }

    const numBoxes = Math.ceil(size / sqftPerBox);
    displayResults(numBoxes, size);
}

function calculateRoomSize(e) {
    const sqftPerBoxEl = document.querySelector('#sqftBx');
    const sqftPerBox = parseFloat(sqftPerBoxEl.textContent);
    const numBoxes = parseFloat(e.target.value);
    if (!numBoxes) {
        return;
    }

    const maxRoomSize = (numBoxes * sqftPerBox).toFixed(2);
    displayResults(numBoxes, maxRoomSize);
}

function handleQuantityButtonChange(e) {
    if (e.type === 'keydown' && e.code !== 'Enter') {
        return;
    }
    setTimeout(() => {
        const quantityInputEl = document.querySelector('input[id=quantityUpdate]');
        if (quantityInputEl) {
            quantityInputEl.dispatchEvent(new Event('input', { bubbles: true}));
        }
    }, 0);
}

function clearCalculationInputs() {
    const numBoxesInput = document.querySelector('#num-boxes');
    const roomSizeInput = document.querySelector('#room-size');
    const totalSfInPurchase = document.querySelector('#purchase-sf');
    numBoxesInput.value = null;
    roomSizeInput.value = null;
    totalSfInPurchase.textContent = '0';
}

domReady(() => {
    const numBoxesInput = document.querySelector('#num-boxes');
    if (numBoxesInput) {
        numBoxesInput.addEventListener('keyup', calculateRoomSize);
        numBoxesInput.addEventListener('click', clearCalculationInputs);
    }

    const roomSizeInput = document.querySelector('#room-size');
    if (roomSizeInput) {
        roomSizeInput.addEventListener('keyup', calculateNumBoxes);
        roomSizeInput.addEventListener('click', clearCalculationInputs);
    }

    const quantityInput = document.querySelector('#quantityUpdate');
    if (quantityInput) {
        quantityInput.addEventListener('input', handleQuantityInputChange);
    }

    const quantitySelectorButtons = document.querySelectorAll('.quantity-selector__button');
    quantitySelectorButtons.forEach((button) => {
        button.addEventListener('click', handleQuantityButtonChange);
        button.addEventListener('keydown', handleQuantityButtonChange);
    });


    attachLightboxListeners();
    const productGalleryImages = document.querySelectorAll('.product-gallery__carousel-item .product-gallery__image');
    productGalleryImages.forEach(img => {
        img.addEventListener('click', openLightbox);
    })
});